<template lang="pug">
  v-app
    v-container(fill-height)
      v-layout(align-center justify-space-around column fill-height)
        a(href="http://stat.kg" class="main-title" target="_blank") {{$t('StartPage.registerBlock.startMessageOne')}}<br> {{$t('StartPage.registerBlock.startMessageTwo')}}
        InnOrganisation(v-if="nextStep === ''", @next-step="showNextForm")
        InnPersonal(v-if="nextStep === 'showInnPersonalForm'", @next-step="showNextForm")
        PinForm(v-if="nextStep === 'showPinForm'", @next-step="showNextForm")
        v-row(align-center justify-center)
          a(href='#' class="lang white--text pr-5" @click="setLocale('ky')") Кыргызча
          a(href='#' class="lang white--text" @click="setLocale('ru')") Русский
        p(class="white--text text-xs-center") © {{$t('StartPage.registerBlock.copyright')}} {{new Date().getFullYear()}}
</template>
<script>
import InnOrganisation from '@/components/LoginPage/common/InnOrganisation'
import PinForm from '@/components/LoginPage/common/PinForm'
import InnPersonal from '@/components/LoginPage/common/InnPersonal'
import Redirect from '@/components/LoginPage/Redirect'
import getBrowserVersion from './BrowserDetect'

export default {
  name: 'LoginPage',
  components: {
    InnOrganisation,
    PinForm,
    InnPersonal,
    Redirect
  },
  data: () => ({
    nextStep: ''
  }),
  methods: {
    showNextForm(val) {
      this.nextStep = val
    },
    setLocale(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
      location.reload()
    }
  },
  mounted() {
    if (!getBrowserVersion) {
      if (navigator.getBrowserVersion.name === 'Chrome') {
        // and Microsoft Edge core Chromium
        if (navigator.getBrowserVersion.version < 92) {
          // eslint-disable-next-line no-lone-blocks
          {
            this.$router.push('/redirect')
          }
        }
      }
      if (navigator.getBrowserVersion.name === 'Opera') {
        if (navigator.getBrowserVersion.version < 75) {
          // eslint-disable-next-line no-lone-blocks
          {
            this.$router.push('/redirect')
          }
        }
      }
      if (navigator.getBrowserVersion.name === 'Firefox') {
        if (navigator.getBrowserVersion.version < 91) {
          // eslint-disable-next-line no-lone-blocks
          {
            this.$router.push('/redirect')
          }
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#app {
  background: url('/static/background.jpg') center center no-repeat;
  .main-title {
    text-decoration: none;
    font-size: 1.7rem;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
    text-align: center;
    width: 100%;
  }
  .main-title:hover {
    font-size: 1.7rem;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: 100%;
    text-decoration: underline;
  }
  .copyright {
    content: '';
    position: absolute;
    bottom: 60px;
    left: 50%;
    transform: translate(-50%, 0);
    color: #fff;
  }
  .lang {
    text-decoration: none;
  }
  .lang:hover {
    text-transform: uppercase;
    text-align: center;
    width: 100%;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginPage/index.vue